<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'inbox'"
    class="page"
  >
    <Header
      :setting="{
        title: '訊息中心',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div v-if="inbox.length === 0">
      目前訊息中心尚無訊息
    </div>
    <div
      v-if="inbox.length !== 0"
      class="pb4 row--evenly"
    >
      <div class="row--start">
        <div
          @click="removeItems()"
          class="label label--secondary row--central"
        >
          <font-awesome-icon :icon="['fas', 'trash']" />
          <div class="ml2">
            刪除
          </div>
        </div>
      </div>
      <div class="row--end">
        <div
          @click="toggleSelectAll()"
          class="label label--primary row--central"
        >
          <font-awesome-icon :icon="['fas', 'mouse-pointer']" />
          <div class="ml2">
            全選
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="item in inbox"
      :key="item"
      @click="showItemModal(item)"
      class="bc--secondary border-radius-hot-dog row--emphasized pv3 ph2 mb4"
    >
      <div class="column--central  mh3">
        {{ spiderman.moment(item.timestamp).format('MM/DD') }}
      </div>
      <div class="column--central">
        <div class="align--left  fc--primary mv2">
          {{ item.title }}
        </div>
        <div class="align--left mv2">
          <span class="ellipsis">
            {{ item.brief }}
          </span>
        </div>
      </div>
      <div class="column--central mh3">
        <input
          @click.stop
          v-model="idIsSelected[item._id]"
          type="checkbox"
          style="transform: scale(1.5)"
        >
      </div>
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toSurveyCake="toSurveyCake"
    @toSatisfactionSurvey="toSatisfactionSurvey"
    @toProgress="toProgress"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';

export default {
  setup() {
    const page = ref('initialization');
    const inbox = ref([]);
    const choosenItem = ref(null);
    const route = useRoute();
    const router = useRouter();
    const idIsSelected = ref({});

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        inbox.value = await api.inboxes.get(composable.member);
        initailizeIsSelected();

        page.value = 'inbox';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    function initailizeIsSelected() {
      idIsSelected.value = {};

      inbox.value.forEach((item) => {
        idIsSelected.value[item._id] = false;
      });
    }

    function toggleSelectAll() {
      const isAllSelected = !Object.values(idIsSelected.value)
        .includes(false);
      if (isAllSelected) initailizeIsSelected();
      else selectAll();
    }

    function selectAll() {
      inbox.value.forEach((item) => {
        idIsSelected.value[item._id] = true;
      });
    }

    async function removeItems() {
      try {
        composable.loading.show('刪除中，請稍候');

        const selectedIds = generateSelectedIds();

        const response = await api.inboxes
          .removeMany(composable.member, selectedIds);
        // 刪除 client端 inbox內的items
        selectedIds.forEach((selectedId) => {
          const removeIndex = inbox.value.findIndex(
            (item) => item._id === selectedId,
          );
          inbox.value.splice(removeIndex, 1);
        });

        initailizeIsSelected();

        composable.modal.popup(response.message);
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function generateSelectedIds() {
      const selectedIds = [];
      Object.entries(idIsSelected.value).forEach(([_id, isSelected]) => {
        if (isSelected) selectedIds.push(_id);
      });

      return selectedIds;
    }

    function showItemModal(item) {
      const modalObject = {
        header: item.title,
        body: item.brief,
        hasCloseButton: false,
        footer: [
          {
            content: '關閉',
            type: 'primary',
            onClickEmit: 'close',
          },
        ],
      };

      if (item.type === 'satisfactionSurvey') {
        modalObject.footer[0].type = 'secondary';
        modalObject.footer.push({
          content: '前往滿意度調查',
          type: 'primary',
          onClickEmit: 'toSurveyCake',
        });
      }
      if (item.type === 'satisfactionSurveyX') {
        modalObject.footer[0].type = 'secondary';
        modalObject.footer.push({
          content: '前往滿意度調查',
          type: 'primary',
          onClickEmit: 'toSatisfactionSurvey',
        });
      }
      // 若有其他類型 就新增if ...
      choosenItem.value = item;

      composable.modal.show(modalObject);
    }

    function toSurveyCake() {
      composable.modal.close();
      console.log('toSurveyCake');
      let cmd;
      console.log('toSurveyCake clinic', composable.member.info.clinic);
      if (composable.member.info.clinic === '璟馨') {
        cmd = spiderman.generate.specialCommand({
          cmd: 'browse',
          url: encodeURI('https://docs.google.com/forms/d/e/1FAIpQLSdOjdj2k6gnTCq8ARnHvPJFOtBU9nedcsN-KR9EgEV-NoNiUQ/viewform?usp=sf_link'),
          timestamp: spiderman.generate.timestamp(),
        });
      }
      if (composable.member.info.clinic === '詠馨') {
        cmd = spiderman.generate.specialCommand({
          cmd: 'browse',
          url: encodeURI('https://docs.google.com/forms/d/e/1FAIpQLScpLFl03G6rnEFJG7ThkLzqOLjG3WzBnPt1KepwT6WP5sD7XA/viewform?usp=sf_link'),
          timestamp: spiderman.generate.timestamp(),
        });
      }
      console.log('toSurveyCake cmd', cmd);
      console.log('toSurveyCake route.path', route.path);
      router.replace(`${route.path}#inncom#${cmd}`);
    }

    function toSatisfactionSurvey() {
      composable.modal.close();
      router.push({
        path: '/inbox/satisfaction-survey',
        query: choosenItem.value,
      });
    }

    function toProgress() {
      composable.modal.close();
      router.push({ path: '/progress' });
    }

    return {
      composable,
      spiderman,
      page,
      inbox,
      idIsSelected,
      toggleSelectAll,
      removeItems,
      showItemModal,
      toSurveyCake,
      toSatisfactionSurvey,
      toProgress,
      console,
    };
  },
};
</script>
